import storage from 'localforage';
import { persistReducer } from 'redux-persist';
import RegionTypes from './types';

export type IRegionState = {
  isLoading: boolean;
  isBlocked: boolean;
  countryCode?: string;
  error?: string | null;
};

export const INITIAL_REGION_STATE: IRegionState = {
  isLoading: false,
  isBlocked: false,
  countryCode: undefined,
  error: null,
};

function regionReducer(state: IRegionState = INITIAL_REGION_STATE, { type, payload }) {
  switch (type) {
    case RegionTypes.SET_REGION_LOADING:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case RegionTypes.SET_REGION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isBlocked: payload.isBlocked,
        countryCode: payload.countryCode,
        error: null,
      };
    case RegionTypes.SET_REGION_ERROR:
      return {
        ...state,
        isLoading: false,
        error: payload.error,
      };
    case RegionTypes.RESET_REGION_STATE:
      return INITIAL_REGION_STATE;
    default:
      return state;
  }
}

const persistConfig = {
  key: 'region',
  storage,
  // Only persist the result, not the loading state
  whitelist: ['isBlocked', 'countryCode'],
};

export default persistReducer(persistConfig, regionReducer);
